import React from "react";
import { Link, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function DetailPageHeader({
  breadcrumbs = [],
  title,
  subtitle,
  listPath,
}) {
  const navigate = useNavigate();

  return (
    <header className="detail-header">
      <div className="detail-header-left">
        {breadcrumbs.length > 0 && (
          <nav className="detail-breadcrumb" aria-label="breadcrumb">
            {breadcrumbs.map((crumb, index) => (
              <React.Fragment key={`${crumb.label}-${index}`}>
                {index > 0 && (
                  <span className="detail-breadcrumb-separator">&gt;</span>
                )}
                {crumb.path ? (
                  <Link to={crumb.path}>{crumb.label}</Link>
                ) : (
                  <span className="detail-breadcrumb-current">{crumb.label}</span>
                )}
              </React.Fragment>
            ))}
          </nav>
        )}

        <h1 className="detail-header-title">{title}</h1>
        {subtitle && <p className="detail-header-subtitle">{subtitle}</p>}
      </div>

      {listPath && (
        <div className="detail-header-actions">
          <button
            type="button"
            className="detail-btn detail-btn-back"
            onClick={() => navigate(listPath)}
          >
            <ArrowBackIcon fontSize="small" />
            Back to List
          </button>
        </div>
      )}
    </header>
  );
}
